import { useCallback, useEffect, useRef } from 'react';

export const useMounted = (): (() => boolean) => {
    const mRef = useRef<boolean>(false);
    const get = useCallback(() => mRef.current, []);

    useEffect(() => {
        mRef.current = true;
        return (): void => {
            mRef.current = false;
        };
    });

    return get;
};
